export const customReset = [
  0.018,
  0.015,
  0.013,
  0.013,
  0.015,
  0.018,
  0.025,
  0.035,
  0.042,
  0.05,
  0.054,
  0.056,
  0.057,
  0.064,
  0.068,
  0.073,
  0.093,
  0.07,
  0.055,
  0.047,
  0.038,
  0.032,
  0.026,
  0.025
];

export const ruralWeekday = [
  0.016,
  0.013,
  0.015,
  0.015,
  0.021,
  0.034,
  0.048,
  0.053,
  0.051,
  0.051,
  0.052,
  0.054,
  0.056,
  0.057,
  0.061,
  0.067,
  0.067,
  0.064,
  0.053,
  0.043,
  0.036,
  0.03,
  0.024,
  0.019
];

export const ruralWeekend = [
  0.019,
  0.016,
  0.013,
  0.015,
  0.016,
  0.021,
  0.029,
  0.036,
  0.044,
  0.052,
  0.060,
  0.065,
  0.066,
  0.066,
  0.067,
  0.069,
  0.067,
  0.062,
  0.055,
  0.048,
  0.04,
  0.033,
  0.026,
  0.015
];

export const urbanWeekday = [
  0.009,
  0.006,
  0.006,
  0.008,
  0.016,
  0.031,
  0.050,
  0.060,
  0.059,
  0.055,
  0.054,
  0.058,
  0.06,
  0.061,
  0.065,
  0.07,
  0.07,
  0.066,
  0.054,
  0.042,
  0.035,
  0.029,
  0.022,
  0.014
];

export const urbanWeekend = [
  0.018,
  0.013,
  0.009,
  0.008,
  0.009,
  0.015,
  0.024,
  0.034,
  0.046,
  0.055,
  0.062,
  0.068,
  0.07,
  0.07,
  0.071,
  0.07,
  0.068,
  0.063,
  0.057,
  0.05,
  0.042,
  0.035,
  0.027,
  0.016
];

export const trafficHourlyDistributions = [
  {name: "Custom", data: customReset},
  {name: "Rural - Weekday", data: ruralWeekday},
  {name: "Rural - Weekend", data: ruralWeekend},
  {name: "Urban - Weekday", data: urbanWeekday},
  {name: "Urban - Weekend", data: urbanWeekend}
];
